import React, { memo, useCallback, useContext } from 'react'

import { number, string } from 'prop-types'

import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import LikeToggle from 'Pods/ThreeDStudio/Shared/Likes/Components/LikeToggle/LikeToggle'
import useModelLike from 'Pods/ThreeDStudio/Shared/Likes/Hooks/useModelLike'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

// The count shows to everyone; liking needs an account, so a signed-out click asks to log in.
// Until /load-services.js resolves the auth state is unknown and reads as signed out, so a
// click in that window is ignored rather than prompting a signed-in viewer to log in. The
// toggle also waits for this image's own like state: before it lands, a click would act on
// a guess (`liked` defaults to false) rather than on the viewer's actual like.
function LikeButton({ slug, title, initialCount = 0 }) {
  const t = useTranslation()
  const { pageConfigLoaded } = useContext(ThreeDStudioPageContext)
  const requireLogin = useRequireLogin('login')
  const {
    isLiked, likeCount, isToggling, isLoaded, toggleLike,
  } = useModelLike({ slug, initialCount, dailyLimitMessage: t('like.dailyLimitReached') })

  const handleClick = useCallback(() => {
    if (!pageConfigLoaded) return
    if (requireLogin()) toggleLike()
  }, [pageConfigLoaded, requireLogin, toggleLike])

  return (
    <LikeToggle
      isLiked={isLiked}
      likeCount={likeCount}
      isToggling={isToggling || !isLoaded}
      title={title}
      customClass="image-gallery-modal__action image-gallery-modal__action--like"
      onClick={handleClick}
    />
  )
}

LikeButton.propTypes = {
  slug: string.isRequired,
  title: string.isRequired,
  initialCount: number,
}

export default memo(LikeButton)
